export default {
  subtitle: 'Klucze uwierzytelniają żądania do Partner API. Wysyłaj je w nagłówku x-api-key.',
  never_used: 'Nigdy nieużywany',
  revoke_confirm: 'Unieważnić ten klucz? Żądania z jego użyciem przestaną działać natychmiast.',
  columns: {
    name: 'Nazwa',
    key: 'Klucz',
    status: 'Status',
    last_used_at: 'Ostatnio użyty',
    created_at: 'Utworzono',
  },
  statuses: {
    active: 'Aktywny',
    revoked: 'Unieważniony',
  },
  buttons: {
    create: 'Utwórz klucz',
    revoke: 'Unieważnij',
  },
  toasts: {
    load_error: 'Nie udało się wczytać kluczy API.',
    error: 'Coś poszło nie tak. Spróbuj ponownie.',
    revoked: 'Klucz API unieważniony.',
  },
};
